import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

/**
 * One-line copyable transaction id badge.
 * Used everywhere a txn id is shown — partner pages, admin pages, receipts,
 * customer notifications — so the same canonical id is visible to all parties.
 */
export function CopyableId({ value, className = "" }) {
  const [copied, setCopied] = useState(false);
  if (!value) return <span className="text-muted-foreground">—</span>;
  const copy = async (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard may be blocked in iframe */
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-1 font-mono text-xs px-1.5 py-0.5 rounded border border-border hover:bg-accent transition-colors ${className}`}
      title={`Click to copy ${value}`}
      data-testid="copyable-txn-id"
    >
      <span>{value}</span>
      {copied
        ? <Check className="h-3 w-3 text-success" strokeWidth={2} />
        : <Copy className="h-3 w-3 text-muted-foreground" strokeWidth={1.5} />}
    </button>
  );
}
